import i18n from 'i18next';
import i18next from 'i18next';
import Backend from 'i18next-http-backend';
import {initReactI18next} from 'react-i18next';
import ENUM_EN from './assets/i18n/enum/en.json';

const detection_settings = {
    order: ['localStorage', 'navigator'],
    caches: ['localStorage']
};

export const t = (key, config) => {
    return i18n.t(key, config);
};

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    detection: detection_settings,
    interpolation: {
      escapeValue: false
    }
  })

i18n.addResourceBundle('en', 'translation', ENUM_EN);

// filter
import FILTER_EN from './feature/filter/i18n/en.json';
import FILTER_LT from './feature/filter/i18n/lt.json';
i18next.addResourceBundle('en', 'filter', FILTER_EN);
i18next.addResourceBundle('lt', 'filter', FILTER_LT);

export default i18n
